<nav aria-label="Page navigation" *ngIf="totalPages > 0">
  <ul class="pagination pagination-sm justify-content-center mt-3">
    <!-- Bouton 'Previous' -->
    <li class="page-item" [class.disabled]="currentPage === 1">
      <a
        class="page-link"
        (click)="changePage(currentPage - 1)"
        tabindex="-1"
        [attr.aria-disabled]="currentPage === 1"
      >
        <span aria-hidden="true">&laquo;</span>
      </a>
    </li>

    <!-- Pages avec ellipses -->
    <li
      *ngFor="let page of getPages()"
      class="page-item"
      [class.active]="currentPage === page"
      [class.disabled]="page === -1"
    >
      <a *ngIf="page !== -1" class="page-link" (click)="changePage(page)">
        {{ page }}
      </a>
      <span *ngIf="page === -1" class="page-link">...</span>
    </li>

    <!-- Bouton 'Next' -->
    <li class="page-item" [class.disabled]="currentPage === totalPages">
      <a
        class="page-link"
        (click)="changePage(currentPage + 1)"
        [attr.aria-disabled]="currentPage === totalPages"
      >
        <span aria-hidden="true">&raquo;</span>
      </a>
    </li>
  </ul>
</nav>
